import { useQuery } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import { getFacilityByIdApi } from './api';

const useFacilityById = ({ facilityId, settings }) => {
  const { enqueueSnackbar } = useSnackbar();

  const { data, isInitialLoading } = useQuery(['facilityById', facilityId], () => getFacilityByIdApi(facilityId), {
    onError: (error) => {
      enqueueSnackbar(error?.response?.data?.message || error.message, { variant: 'error' });
    },
    select: ({ data }) => data,
    ...settings,
  });

  return { data, isLoading: isInitialLoading };
};

export default useFacilityById;
